import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import experienceService from '../../../services/api/experienceService';
import { Button } from 'semantic-ui-react';
import { getOneEventPerDay } from './volunteersArea';
import { clickableStyles } from '../../../components/helpers';
import { cancelThisWeekendService, thisWeekendService } from './confirmationHelpers';
import { TableContainerComponent } from 'src/assets/styles/components/Table';
import AGTable from '../../../components/table/aggrid';
import VolunteerForm from './VolunteerForm';
import { ExperienceTeamAreaRowDef } from '../../../components/common/rows/ExperienceTeamAreaRow';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

const VolunteersBySection = ({
  volunteers,
  history,
  set_loading,
  loading,
  eventSlugname,
  getInfo,
  services,
  inputs,
  showSubsection = false,
}) => {
  const [volunteersByEvent, set_volunteersByEvent] = useState([]);
  const [volunteersRowChecks, set_volunteersRowChecks] = useState([]);
  const [showImgs, set_showImgs] = useState(true);
  const [editingVolunteer, set_editingVolunteer] = useState(null);
  const [openVolLeaders, setOpenVolLeaders] = useState(null);
  const getCaptchaToken = useRecaptchaToken('volunteer_service_logs');

  useEffect(() => {
    getVolunteersByEvent();
  }, [services]);

  const getVolunteersByEvent = async () => {
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    experienceService
      .getAllVolunteerServiceLogs({
        eventSlugname,
        ...(captchaRequired ? { captcha } : {}),
      })
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_volunteersRowChecks([]);
          set_volunteersByEvent(response.data.volunteersByEvent);
        } else if (response.data.message) {
          Swal.fire(response.data.message);
        }
      })
      .catch((err) => {
        set_loading(false);
        if (err?.response?.data?.message) Swal.fire(err.response.data.message);
      });
  };

  const service = getOneEventPerDay(services)?.find((a) => inputs.event_id === a?.id);

  const isVolunteerReserved = (volunteerId) => {
    return volunteersByEvent
      ?.find?.((event) => inputs.event_id === event?.id)
      ?.EventVolunteers?.some((reserved) => Number(reserved.volunteer_id) === Number(volunteerId));
  };

  const isVolunteerChecked = (volunteerId) => {
    return volunteersRowChecks?.some(
      (volunteerCheck) => volunteerCheck.volunteer_id === volunteerId
    );
  };

  const handleCheckboxChange = (volunteer) => {
    const { id, Guest, suspended } = volunteer;

    if (suspended) return;

    if (isVolunteerChecked(id)) {
      set_volunteersRowChecks((prev) =>
        prev.filter((volunteerCheck) => volunteerCheck.volunteer_id !== id)
      );
    } else {
      set_volunteersRowChecks((prev) => [...prev, { guest_id: Guest.id, volunteer_id: id }]);
    }
  };

  const handleSelectAll = () => {
    const nonSuspendedVolunteers = volunteers?.filter((v) => !v.suspended);

    if (volunteersRowChecks?.length === nonSuspendedVolunteers?.length) {
      set_volunteersRowChecks([]);
    } else {
      set_volunteersRowChecks(
        nonSuspendedVolunteers?.map((volunteer) => ({
          guest_id: volunteer?.Guest?.id,
          volunteer_id: volunteer?.id,
        }))
      );
    }
  };

  const columnDefs = ExperienceTeamAreaRowDef({
    loading,
    service,
    eventSlugname,
    getVolunteersByEvent,
    set_loading,
    showImgs,
    mainInputs: inputs,
    getInfo,
    isVolunteerReserved,
    isVolunteerChecked,
    handleCheckboxChange,
    handleSelectAll,
    volunteersRowChecks,
    volunteers,
    set_editingVolunteer,
    openVolLeaders,
    setOpenVolLeaders,
    showArea: false,
    showLeaders: true,
    showEdit: true,
    showActive: false,
    grouped: true,
    showDocs: true,
    showConvenio: true,
    showSubsection,
  });

  return (
    <TableContainerComponent>
      {volunteersRowChecks.length > 0 && (
        <>
          <p style={{ margin: '20px 0 0 0' }}>
            Seleccionados: {volunteersRowChecks.length} -{' '}
            <span style={clickableStyles} onClick={() => set_volunteersRowChecks([])}>
              Limpiar
            </span>
          </p>
          <Button
            primary
            disabled={loading}
            onClick={() =>
              thisWeekendService(
                volunteersRowChecks,
                service,
                eventSlugname,
                {},
                getVolunteersByEvent,
                set_loading
              )
            }
          >
            Confirmar seleccionados
          </Button>
          <Button
            disabled={loading}
            onClick={() =>
              cancelThisWeekendService(
                volunteersRowChecks.map((volunteer) => volunteer.volunteer_id),
                service,
                eventSlugname,
                {},
                getVolunteersByEvent,
                set_loading
              )
            }
          >
            Cancelar seleccionados
          </Button>
        </>
      )}
      <Button primary onClick={() => set_showImgs(!showImgs)}>
        {showImgs ? 'Ocultar' : 'Mostrar'} fotos
      </Button>

      <AGTable
        rowData={volunteers}
        columnDefs={columnDefs}
        rowHeight={showImgs ? 90 : 60}
        defaultCol={{
          suppressMovable: true,
        }}
      />

      {editingVolunteer && (
        <VolunteerForm
          prevVolunteerInputs={{ ...editingVolunteer?.Guest, ...editingVolunteer }}
          set_showVolunteerForm={(val) => set_editingVolunteer(val ? editingVolunteer : null)}
          set_loading={set_loading}
          mainInputs={inputs}
          getInfo={getInfo}
          loading={loading}
        />
      )}
    </TableContainerComponent>
  );
};

export default VolunteersBySection;
